(function () {
  'use strict';

  var selectedProductId = null;
  var sizeChosen = false;

  function sizeFieldset(picker) {
    return Array.from(picker.querySelectorAll('fieldset')).find(function (fieldset) {
      var legend = fieldset.querySelector('legend');
      return legend && legend.textContent.trim().toLowerCase().indexOf('size') === 0;
    });
  }

  function context() {
    var info = document.querySelector('.product-information');
    var picker = info && info.querySelector('variant-picker');
    var form = info && info.querySelector('product-form-component form');
    var fieldset = picker && sizeFieldset(picker);
    if (!fieldset || !form || fieldset.querySelectorAll('input[type="radio"]').length < 2) return null;

    var productId = picker.dataset.productId || form.id;
    if (selectedProductId !== productId) {
      selectedProductId = productId;
      sizeChosen = false;
    }
    return { info: info, picker: picker, form: form, fieldset: fieldset };
  }

  function message(fieldset) {
    var element = fieldset.querySelector('.bbc-size-choice-message');
    if (!element) {
      element = document.createElement('p');
      element.className = 'bbc-size-choice-message';
      element.setAttribute('role', 'status');
      element.textContent = 'Choose a size to add to cart.';
      fieldset.appendChild(element);
    }
    return element;
  }

  function sync() {
    var ctx = context();
    if (!ctx) return;
    if (!sizeChosen) {
      ctx.fieldset.querySelectorAll('input[type="radio"]').forEach(function (radio) {
        radio.checked = false;
      });
    }
    /* Mobile QA fix (2026-10-23): the prompt used to be removed from layout once a
       size was picked, which jumped the add to cart button up by its height just as
       the shopper reached for it. Keep its box and hide it in place instead, so the
       button never moves. */
    var note = message(ctx.fieldset);
    note.hidden = false;
    note.style.visibility = sizeChosen ? 'hidden' : 'visible';
    ctx.info.dataset.bbcSizeChosen = String(sizeChosen);
    ctx.info.querySelectorAll('accelerated-checkout, .shopify-payment-button').forEach(function (element) {
      element.style.display = sizeChosen ? '' : 'none';
    });
  }

  function syncFormVariant(ctx) {
    var selected = ctx.fieldset.querySelector('input[type="radio"]:checked');
    var input = ctx.form.querySelector('input[name="id"]');
    if (!selected || !input || !selected.dataset.variantId) return false;
    var variant;
    try { variant = JSON.parse(ctx.picker.querySelector('script[type="application/json"]').textContent); }
    catch (error) { return false; }
    var choices = Array.from(ctx.picker.querySelectorAll('fieldset.variant-option')).map(function (fieldset) {
      return fieldset.querySelector('input:checked')?.value;
    });
    if (!variant || String(variant.id) !== selected.dataset.variantId ||
        choices.some(function (choice, index) { return choice !== variant.options[index]; })) return false;
    input.value = selected.dataset.variantId;
    return true;
  }

  function requireSize(event) {
    var ctx = context();
    if (!ctx) return;
    if (sizeChosen) {
      if (syncFormVariant(ctx)) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }
    event.preventDefault();
    event.stopImmediatePropagation();
    sync();
    ctx.fieldset.scrollIntoView({ behavior: 'smooth', block: 'center' });
    var first = ctx.fieldset.querySelector('input[type="radio"]');
    if (first) first.focus({ preventScroll: true });
  }

  document.addEventListener('change', function (event) {
    var ctx = context();
    if (!ctx || !(event.target instanceof HTMLInputElement) || !ctx.picker.contains(event.target)) return;
    if (event.target.type === 'radio' && ctx.fieldset.contains(event.target)) {
      sizeChosen = true;
    }
    sync();
  }, true);

  document.addEventListener('click', function (event) {
    var target = event.target instanceof Element ? event.target : null;
    var button = target && target.closest('.add-to-cart-button, .sticky-add-to-cart__button, button[name="add"]');
    if (!button || (!button.closest('.product-information') && !button.closest('.sticky-add-to-cart'))) return;
    requireSize(event);
  }, true);

  document.addEventListener('submit', function (event) {
    var ctx = context();
    if (ctx && event.target === ctx.form) requireSize(event);
  }, true);

  function init() {
    new MutationObserver(sync).observe(document.body, { childList: true, subtree: true });
    sync();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
